import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getBillingInformation } from 'modules/settings/api';

export const useQueryBillingInformation = (customerId: string | number | undefined) => {
  const {
    data: billingInformationData,
    isLoading: billingInformationLoading,
    isError: billingInformationError,
    isFetching: billingInformationIsFetching,
  } = useQuery(
    [QUERY_KEYS.SETTINGS_PROFILE_BILLING_INFORMATION],
    () => getBillingInformation(customerId),
    {
      enabled: !!customerId,
    },
  );

  return {
    billingInformationData,
    billingInformationLoading,
    billingInformationError,
    billingInformationIsFetching,
  };
};
